import { render, staticRenderFns } from "./ReceptorModal.vue?vue&type=template&id=6b30c172"
import script from "./ReceptorModal.vue?vue&type=script&lang=js"
export * from "./ReceptorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports